import React from "react";
import { Link } from "react-router-dom";

const NewsHomeGrid = ({ items, children }) => {
  // Ordena os serviços pelo ID e seleciona os 3 últimos
  const lastThreeItems = items
    .sort((a, b) => b.ID - a.ID) // Ordena por ID em ordem decrescente
    .slice(0, 3); // Pega os 3 primeiros após a ordenação

  return (
    <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-3 mt-4">
      {lastThreeItems.map((service) => (
        <Link
          key={service.ID} // Use `id` do JSON como chave única
          to={`/noticias/${service.ID}`} // Define o link para a página da notícia
          className="relative group block bg-cover bg-center aspect-square h-50 md:h-80 lg:h-96 rounded-2xl overflow-hidden shadow-lg"
          style={{ backgroundImage: `url(${service.file.url})` }}
        >
          <div className="absolute inset-0 bg-yellow-400 bg-opacity-0 group-hover:bg-opacity-75 transition duration-300 ease-in-out"></div>
          <div className="absolute inset-0 flex flex-col items-center justify-center p-4">
            <h3 className="text-blue-950 text-center opacity-0 text-2xl font-bold mb-2 transform group-hover:opacity-100 -translate-y-2 transition duration-300 ease-in-out">
              {service.title}
            </h3>
          </div>
        </Link>
      ))}
      {/* Insere qualquer conteúdo adicional passado como children */}
      {React.Children.map(children, (child, index) => (
        <div key={`child-${index}`}>{child}</div>
      ))}
    </div>
  );
};

export default NewsHomeGrid;
